<template>
    <div class="site-menu-container" :class="{ 'site-menu-container--open': isOpenOnMobile }">
        <div class="container position-relative px-0">
            <button v-if="openedMenuItem !== null" class="site-menu__back" @click="mobileMoveBack()">
                {{ goBackTitlesStack[goBackTitlesStack.length - 1] }}
            </button>
            <MenuDesktop
                :items="items"
                :menu-banners="menuBanners"
                :menu-brand-banners="menuBrandBanners"
                :sale-banners="saleBanners"
                :pinned-categories="pinnedCategories"
                :menu-item-products="menuItemProducts"
                :xmas-category-id="xmasCategoryId"
                :menu-highlight-category="menuHighlightCategory"
                :is-pwa="isPwa"
                :product-amounts="productAmounts"
                :dictionary="dictionary"
                @menuMouseOver="$emit('menuMouseOver')"
                @addProductToBasket="addProductToBasket"
                @redirectToUrl="redirectToUrl"
            >
                <template v-slot:product="{ product }">
                    <slot name="product" v-bind="{ product }"></slot>
                </template>
            </MenuDesktop>
        </div>
    </div>
</template>
<script>
import MenuDesktop from './MenuDesktop'

export default {
    components: {
        MenuDesktop,
    },

    props: {
        productAmounts: {
            type: Object,
            required: true,
        },
        isPwa: {
            type: Boolean,
            required: true,
        },
        isOpenOnMobile: {
            default: false,
            type: Boolean,
        },
        items: {
            default: false,
        },
        pinnedCategories: {
            default: false,
        },
        menuBanners: {
            default: false,
        },
        menuBrandBanners: {
            type: Array,
        },
        saleBanners: {
            type: Array,
            default: null,
        },
        menuItemProducts: {
            default: false,
        },
        xmasCategoryId: {
            type: Number,
            required: false,
        },
        menuHighlightCategory: {
            default: false,
        },
        dictionary: {
            type: Object,
            required: true,
        },
    },

    methods: {
        addProductToBasket(data) {
            this.$emit('addProductToBasket', data)
        },

        redirectToUrl(data) {
            this.$emit('redirectToUrl', data)
        },
    },

    data() {
        return {
            openedMenuItem: null,
            goBackTitlesStack: [],
        }
    },
}
</script>
<style lang="scss" scoped>
.container {
    max-width: 100%;
}

.site-menu-container {
    padding: 5px 0;

    @media (min-width: 992px) {
        //margin: 5px 15px;
        padding: 5px 15px 0px;
    }
}
</style>
